import { render } from "./ForecastInputsTable.vue?vue&type=template&id=7c4dc7bc&scoped=true"
import script from "./ForecastInputsTable.vue?vue&type=script&lang=js"
export * from "./ForecastInputsTable.vue?vue&type=script&lang=js"

import "./ForecastInputsTable.vue?vue&type=style&index=0&id=7c4dc7bc&scoped=true&lang=css"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4dc7bc"]])

export default __exports__